import { Helmet } from "react-helmet";
import { SortOrder } from "@covertree/agent-portal-graphql";
import { TableView } from "@covertree/ui/table/TableView";

import { useGetQuotes } from "./useGetQuotes";
import formatPageTitle from "@utils/formatPageTitle";

export default function Quotes() {
  const {
    loading,
    error,
    quotes,
    columns,
    filters,
    sortBy,
    order,
    totalCount,
    rowsPerPage,
    currentPage,
    handleChangePage,
    handleFilterChange,
    handleSortChange,
    handleRowsPerPageChange,
  } = useGetQuotes();

  return (
    <>
      <Helmet>
        <title>{formatPageTitle("Quotes")}</title>
      </Helmet>
      <TableView
        header="Quotes"
        loading={loading}
        error={error}
        tabs={filters}
        totalCount={totalCount}
        page={currentPage}
        rows={quotes}
        rowsPerPage={rowsPerPage}
        sortBy={sortBy}
        sortOrder={order === SortOrder.Ascending ? "asc" : "desc"}
        columns={columns}
        onTabChange={handleFilterChange}
        onPageChange={handleChangePage}
        onSortChange={handleSortChange}
        onRowsPerPageChange={handleRowsPerPageChange}
      />
    </>
  );
}
